import React, {useState, useEffect, useRef} from 'react';
import {PageGrid} from '@/component';
import {PageHeader, Button, Input, Select, message, Spin} from 'antd';
import {TwoColumnLayout} from '@/component';
import {SyncOutlined, TagOutlined} from '@/icons';
import styles from '../index.module.less';
import {useAuthStore} from '@/context/auth';
import _ from 'lodash';
import {getColumns} from '@/page/customer/ConsentPage/customerColumns';
import ReasonModal from '@/page/customer/ConsentPage/ReasonModal';
import {useEditAuthService} from '@/page/admin/adminService';
import {consentList, getCustomerList} from '@/api/customer';
import CreateExcel from 'js-export-excel';
import dayjs from 'dayjs';

const {Option} = Select;

function ConsentPage() {
    const editable = useEditAuthService(['global:sys_consent_list:w']);
    const reasonRef = useRef();
    const tableRef = useRef();
    const [authStore] = useAuthStore();
    const userId = _.get(authStore, 'user.extId');
    const [url, setUrl] = useState(null);
    const [externaluserId, setExternaluserId] = useState(null);
    const [loading, setLoading] = useState(false);
    const [searchParam, setSearchParam] = useState({
        name: '',
        follow: '',
        type: 0,
        userId: userId,
    });

    const extra = (
        <Input.Group compact>
            <Input
                className={styles.baseSearch}
                placeholder="请输入客户名称"
                onChange={changeName}
            />
            <Input
                className={styles.baseSearch}
                placeholder="请输入跟进员工编号或名称"
                onChange={changeFollow}
            />
            <Select defaultValue="0" className={styles.baseSelect} onChange={changeSelect}>
                <Option value="0">全部</Option>
                <Option value="1">微信客户</Option>
                <Option value="2">企业微信客户</Option>
            </Select>
            <Button type="primary" style={{marginLeft: '10px'}} onClick={search}>
                查询
            </Button>
            <Button type="primary" style={{marginLeft: '10px'}} onClick={exportExcel}>
                导出
            </Button>
        </Input.Group>
    );
    let columns = getColumns();
    columns.push({
        title: '操作',
        dataIndex: 'action',
        align: 'center',
        render: (text, record) => (
            <Button
                disabled={!editable}
                type="text"
                onClick={() => consent(record)}
                icon={<TagOutlined />}
                style={{color: '#152D85'}}
            >
                DeConsent
            </Button>
        ),
    });
    useEffect(() => {
        setUrl('/customer/consent/list');
    }, []);

    function changeName(e) {
        let temp = {...searchParam};
        temp.name = e.target.value;
        setSearchParam(temp);
    }

    function changeFollow(e) {
        let temp = {...searchParam};
        temp.follow = e.target.value;
        setSearchParam(temp);
    }

    function changeSelect(e) {
        let temp = {...searchParam};
        temp.type = parseInt(e, 10);
        setSearchParam(temp);
    }

    function search() {
        const {name, type, follow} = searchParam;
        setUrl(
            `/customer/consent/list?name=${encodeURIComponent(name)}&type=${encodeURIComponent(
                type
            )}&follow=${encodeURIComponent(follow)}`
        );
    }

    function consent(record) {
        setExternaluserId(record.externalUserid);
        reasonRef.current.open(record.externalUserid);
    }

    function reload() {
        tableRef.current.refresh();
    }

    function exportExcel() {
        setLoading(true);
        let params = {...searchParam};
        params.current = 1;
        params.size = 99999;
        consentList(params).then(res => {
            console.log(res);
            if (res.data.records.length > 0) {
                let {records} = res.data;
                let option = {
                    fileName: 'consent列表',
                };
                let dataTable = [];
                records.forEach(item => {
                    let {
                        customerName,
                        externalUserid,
                        userName,
                        consentTime,
                        gender,
                        type,
                        tagLinks,
                        identity,
                        extId,
                        realName,
                    } = item;
                    let tags = '';
                    if (tagLinks.length > 0) {
                        tagLinks.forEach(tag => {
                            tags = tags + ',' + tag.tagName;
                        });
                    }
                    if (tags !== '') tags = tags.substring(1, tags.length);
                    let data = {
                        客户昵称: customerName,
                        客户实名: realName,
                        externalUserid: externalUserid,
                        跟进员工: `${userName}(${extId})`,
                        最后签署时间: consentTime,
                        客户性别: gender == 0 ? '未知' : gender == 1 ? '男' : '女',
                        客户类型: type == 0 ? '' : type == 1 ? '微信客户' : '企业成员',
                        标签: tags,
                        身份: identity,
                    };
                    dataTable.push(data);
                });
                option.datas = [
                    {
                        sheetData: dataTable,
                        sheetName: 'sheet',
                        sheetFilter: [
                            '客户昵称',
                            '客户实名',
                            'externalUserid',
                            '跟进员工',
                            '最后签署时间',
                            '客户性别',
                            '客户类型',
                            '标签',
                            '身份',
                        ],
                        sheetHeader: [
                            '客户昵称',
                            '客户实名',
                            'externalUserid',
                            '跟进员工',
                            '最后签署时间',
                            '客户性别',
                            '客户类型',
                            '标签',
                            '身份',
                        ],
                    },
                ];
                let toExcel = new CreateExcel(option);
                toExcel.saveExcel();
                setLoading(false);
            } else {
                message.info('无数据导出');
                setLoading(false);
            }
        });
    }

    return (
        <TwoColumnLayout>
            <TwoColumnLayout.ContentPanel>
                <div className={styles.header}>
                    <PageHeader title="consent列表" extra={extra} />
                </div>
                <Spin spinning={loading}>
                    <div className={styles.tableContainer}>
                        {searchParam && url && (
                            <PageGrid
                                url={url}
                                columns={columns}
                                initParams={searchParam}
                                ref={tableRef}
                            />
                        )}
                        <ReasonModal
                            ref={reasonRef}
                            reload={reload}
                            externaluserId={externaluserId}
                        />
                    </div>
                </Spin>
            </TwoColumnLayout.ContentPanel>
        </TwoColumnLayout>
    );
}

export default ConsentPage;
